module.exports = __webpack_public_path__ + "static/media/uj_profil.e8c38e4a.jpg";